<template>
  <div class="transaction-type-selector">
    <div class="selector-title">{{ $gettext('Type') }}</div>
    <b-dropdown :text="selectedValue.name" variant="primary" right class="transaction-type-dropdown ui-dashboard-menu-dropdown">
      <b-dropdown-item 
        v-for="transactionType in transactionTypeList" 
        :key="'transtype-' + transactionType.id" 
        @click="selectOption(transactionType)" 
        class="list-item"
      >
        {{ transactionType.name }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
export default {
  name: "TransactionTypeFilter",
  components: {},
  props: {
    value: String,
    hideAll: Boolean,
  },
  data () {
    return {
      transactionTypeList: [
        { id: 'unassigned', name: this.$gettext('Business') },
        { id: 'taxes', name: this.$gettext('Taxes') },
        { id: 'private', name: this.$gettext('Private') }
      ],
    }
  },
  computed: {
    selectedValue () {
      return (this.isBusiness) ? 
              this.transactionTypeList[0] : 
              this.transactionTypeList.filter(filter_type => { return filter_type.id === this.value })[0]
    },
    isBusiness () {
      return (RegExp('matched_with').test(this.value) || this.value === 'unassigned' || this.value === 'others');
    }
  },
  created () {
  },
  methods: {
    selectOption (option) {
      this.$emit('type-selected', option.id);
    }
  }
}
</script>
<style lang="scss">
.transaction-type-selector {
  .transaction-type-dropdown {
    .dropdown-toggle {
      box-shadow: $filtersShadow !important;
      border-radius: $radiusMd;
      border: none;
      // background: rgba(34, 172, 138, 0.07);
      // color: $colorTextBase;
    }
    // &.show > .dropdown-toggle, .dropdown-toggle:active { background: $colorBrand !important; }
  }
}
</style>
<style lang="scss" scoped>
.transaction-type-selector {
  display: flex;
  align-items: center;
  .selector-title { 
    color: $colorUnassigned;
    margin-right: 0.5rem;
  }
}
</style>
